import { render, staticRenderFns } from "./UsersOwn.vue?vue&type=template&id=986b0ca8&"
import script from "./UsersOwn.vue?vue&type=script&lang=js&"
export * from "./UsersOwn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports